import React from "react";
import { CourseRealtimeProvider } from "./CourseRealtime";
import IncomingMessagePrompt from "../Thread/IncomingMessagePrompt";
import { coursesEnabled, courseApiEnabled } from "../../config/courseFeatures";

export default function CourseThreadNotifications({ children }) {
  const enabled = coursesEnabled && courseApiEnabled;
  return <CourseRealtimeProvider enabled={enabled} brand="course_pivot">{children}{enabled && <IncomingMessagePrompt ordersEnabled={false} />}</CourseRealtimeProvider>;
}
